// @todo: Migrate to 'Avatar' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Avatar} from '@material-ui/core';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const EntityOption = styled.div`
  display: flex;
  align-items: center;
`;

interface AvatarImageProps {
  size: string;
}

export const AvatarImage = styled(Avatar)<AvatarImageProps>`
  && {
    width: ${props => (props.size === 'small' ? 16 : 20)}px;
    height: ${props => (props.size === 'small' ? 16 : 20)}px;
  }
  margin-right: 8px;
  img {
    object-fit: contain;
  }
`;

export const EntityOptionLabel = styled.div`
  flex: 1 1 auto;
`;
